// API Base URL Configuration
const url = process.env.REACT_APP_API_URL;// || "http://localhost:5000";

export default url;